import { withTitle } from '@gik/core/hocs/withTitle';
import routes from '@gik/core/routes';
import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import GoneImage from '@gik/inkind-page/assets/img/gone.svg';
import { openSearch } from '@gik/search/components/SearchStore';
import { Button } from '@gik/ui/Button';
import { PageSection } from '@gik/ui/gik/PageSection';
import React from 'react';

function InkindDeactivatedPageComp() {
  const bem = useBemCN('inkind-deactivated-page');

  return withTitle(
    'Inkind Page Not Found',
    <PageSection {...bem()}>
      <div {...bem('content')}>
        <div {...bem('main')}>
          <h1>InKind Page not found</h1>
          <p>
            The InKind Page you have been linked to no longer exists. The URL may have been entered incorrectly, or the
            page was deactivated by the organizer.
          </p>
          <p>
            If you believe the page you’re looking for is still active, please double-check your link, or you can{' '}
            <Button
              variant="primary-link"
              onClick={() => {
                openSearch('InkindPageNotFound');
              }}
            >
              search Give InKind
            </Button>{' '}
            to find the page.
          </p>
          <p>
            If you’ve tried the above methods but are still seeing this message,{' '}
            <Button variant="primary-link" href="https://help.giveinkind.com/en" target="_blank">
              contact customer support
            </Button>
            .
          </p>
        </div>
        <GoneImage {...bem('image')} />
      </div>
      <div {...bem('actions')}>
        <a href={routes.home}>
          <Button>Take me home</Button>
        </a>
      </div>
    </PageSection>
  );
}

export const InkindDeactivatedPage = withComponentErrorBoundary(InkindDeactivatedPageComp);
